import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.saml.providers');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-saml-providers',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.saml.providers/view.scss */
/* src/app/portal.saml.providers/view.scss: no such file or directory */`],
})
export class PortalSamlProvidersComponent implements OnInit {
    @Input() search = false;

    public constructor(@Inject( Service)         public service: Service,    ) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public text = "";
    public list = [];
    public async load() {
        this.list = [];
        const { code, data } = await wiz.call("load");
        if (code !== 200) return await this.service.error("Failed to load SAML IdP Providers");
        this.list = data;
        await this.service.render();
    }

    public filter(item) {
        const targets = ["key", "display_name"];
        const t = this.text.toLowerCase();
        for (let target of targets) {
            let tmp = item[target];
            if (tmp === undefined) continue;
            tmp = tmp.toLowerCase();
            if (tmp.includes(t)) return true;
        }
        return false;
    }
}

export default PortalSamlProvidersComponent;